/*!
 * Helpers
 * Static helper methods.
 */

export default class Helpers {
  static Debounce(func, wait, immediate) {
    let timeout;
    return function () {
      let context = this,
        args = arguments;
      let later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      let callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  static Throttle(func, delay) {
    let timeoutId;
    return (...args) => {
      if (!timeoutId) {
        timeoutId = setTimeout(() => {
          func(...args);
          timeoutId = null;
        }, delay);
      }
    };
  }

  static NextId(data, prop) {
    if (!data) {
      console.error("NextId data is null");
      return;
    }
    const max = data.reduce(function (prev, current) {
      if (+parseInt(current[prop]) > +parseInt(prev[prop])) {
        return current;
      } else {
        return prev;
      }
    });
    return parseInt(max[prop]) + 1;
  }

  static FetchJSON(path, onComplete) {
    fetch(path)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => onComplete(data))
      .catch((error) => {
        console.error("Problem with the fetching JSON data: ", error);
      });
  }

  static AddCommas(nStr) {
    nStr += "";
    let x = nStr.split(".");
    let x1 = x[0];
    let x2 = x.length > 1 ? "." + x[1] : "";
    let rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, "$1" + "," + "$2");
    }
    return x1 + x2;
  }

  static UrlFix(paramPath) {
    const dataPrefix = document.documentElement.dataset.urlPrefix;
    if (!dataPrefix) {
      return paramPath;
    }
    const prefix = dataPrefix.endsWith("/") ? dataPrefix : `${dataPrefix}/`;
    const path = paramPath.startsWith("/") ? paramPath.slice(1, paramPath.length) : paramPath;
    return `${prefix}${path}`;
  }
}
